<template>
  <v-container class="pt-6">
    <v-row>
      <v-col cols="12">
        <v-tabs
          v-model="tab"
          class="arrange-tabs"
          height="80"
        >
          <v-tab
            class="elevation-12 primary--text"
            key="nn"
            @click="saveSelectedTabToStore"
          >
            <v-card-title class="primary--text" >
              <img src="@/assets/images/noun-house.png" alt="" />
              <span class="pl-4">
                NN
              </span>
            </v-card-title>
          </v-tab>

          <v-tab
            class="elevation-12 primary--text"
            key="vn"
            @click="saveSelectedTabToStore"
          >
            <v-card-title class="primary--text">
              <img src="@/assets/images/noun-offices.png" alt="" />
              <span class="pl-4">
                VN a VVN
              </span>
            </v-card-title>
          </v-tab>
        </v-tabs>

        <v-card class="elevation-12">
          <v-card-title class="px-9 pt-7">
            Potřebuji zařídit
          </v-card-title>

          <v-tabs-items v-model="tab">
            <v-tab-item key="nn">
              <v-card-text class="pt-0">
                <v-row v-if="accessFor(['ROLE_ADMIN', 'ROLE_DEALER'])">
                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                  >
                    <v-card
                      :to="{ name: 'collectionPoint' }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Informace o odběrném místě
                      </v-card-title>

                      <v-card-text>
                        Zadejte EAN vašeho zákazníka a zjistíte
                        veškeré důležité informace o jeho odběrném místě.
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                  >
                    <v-card
                      :to="{ name: 'interruptionOrRenewalOfDistribution' }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Přerušení / obnovení distribuce elektřiny
                      </v-card-title>

                      <v-card-text>
                        Ať už máte důvod jakýkoliv, přerušení nebo
                        obnovení distribuce elektřiny můžete vyřídit zde.
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                    v-if="isActiveProcess('REQUEST')"
                  >
                    <v-card
                      :to="{ name: 'requestNN' }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Žádost NN<br><small>(změna charakteru odběru)</small>
                      </v-card-title>

                      <v-card-text>
                        Lorem ipsum dolor sit amet
                        consectetur, adipisicing elit.
                      </v-card-text>
                    </v-card>
                  </v-col>

<!--                  <v-col-->
<!--                    cols="12"-->
<!--                    sm="6"-->
<!--                    lg="4"-->
<!--                    v-if="isActiveProcess('UPDATE_CONTRACTS')"-->
<!--                  >-->
<!--                    <v-card-->
<!--                      :to="{ name: 'updateFrameworkContractsNN' }"-->
<!--                      outlined-->
<!--                      tile-->
<!--                      hover-->
<!--                      class="fill-height"-->
<!--                    >-->
<!--                      <v-card-title class="primary&#45;&#45;text">-->
<!--                        Aktualizace RSD NN-->
<!--                      </v-card-title>-->

<!--                      <v-card-text>-->
<!--                        Lorem ipsum dolor sit amet-->
<!--                        consectetur, adipisicing elit.-->
<!--                      </v-card-text>-->
<!--                    </v-card>-->
<!--                  </v-col>-->

                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                  >
                    <v-card
                      :to="{ name: 'reportReading' }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Nahlášení odečtu
                      </v-card-title>

                      <v-card-text>
                        Potřebujete nám nahlásit kontrolní odečet,
                        odečet ke změně dodavatele nebo k
                        mimořádné fakturaci?
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                    v-if="isActiveProcess('AGREEMENT_ATTACHMENT')"
                  >
                    <v-card
                      :to="{ name: 'agreementAttachment', query: { level: 'NN' } }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Přílohy rámcových smluv
                      </v-card-title>

                      <v-card-text>
                        Každý 5. pracovní den v měsíci zde najdete aktuální seznam vašich zákazníků
                        v rozsahu a struktuře dle vyhlášky č. 408/2015 Sb. (příloha č. 2).
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>

            <v-tab-item key="vn">
              <v-card-text class="pt-0">
                <v-row v-if="accessFor(['ROLE_ADMIN', 'ROLE_DEALER'])">
                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                  >
                    <v-card
                      :to="{ name: 'collectionPoint' }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Informace o odběrném místě
                      </v-card-title>

                      <v-card-text>
                        Zadejte EAN vašeho zákazníka a zjistíte
                        veškeré důležité informace o jeho odběrném místě.
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                    v-if="isActiveProcess('UPDATE_CONTRACTS')"
                  >
                    <v-card
                      :to="{ name: 'updateFrameworkContractsVN' }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Změna rezervované kapacity
<!--                        Aktualizace RSD VN-->
                      </v-card-title>

                      <v-card-text>
                        Roční nebo měsíční rezervovanou kapacitu lze upravit dle potřeb
                        vašeho zákazníka.
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                  >
                    <v-card
                      :to="{ name: 'interruptionOrRenewalOfDistribution' }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Přerušení / obnovení distribuce elektřiny
                      </v-card-title>

                      <v-card-text>
                        Ať už máte důvod jakýkoliv, přerušení nebo
                        obnovení distribuce elektřiny můžete vyřídit zde.
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                  >
                    <v-card
                      :to="{ name: 'trialOperation' }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Zkušební provoz
                      </v-card-title>

                      <v-card-text>
                        Zkušební provoz neboli provoz pro ověření
                        technologie zákazníka lze využít pro nově
                        instalované či rekonstruované elektrické
                        zařízení až po dobu 3 měsíců.
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                  >
                    <v-card
                      :to="{ name: 'billingException' }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Výjimka z fakturace
                      </v-card-title>

                      <v-card-text>
                        Pokud víte, že váš zákazník nebude schopen
                        dodržet některé smluvně sjednané parametry
                        (účiník, rezervovaný příkon nebo kapacitu)
                        např. v důsledku poruchy, můžete požádat o
                        výjimku z fakturace.
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                    v-if="isActiveProcess('REQUEST')"
                  >
                    <v-card
                      :to="{ name: 'requestVN' }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Žádost VN
                      </v-card-title>

                      <v-card-text>
                        Žádost VN
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                    v-if="isActiveProcess('AGREEMENT_ATTACHMENT')"
                  >
                    <v-card
                      :to="{ name: 'agreementAttachment', query: { level: 'VN' } }"
                      outlined
                      tile
                      hover
                      class="fill-height"
                    >
                      <v-card-title class="primary--text">
                        Přílohy rámcových smluv
                      </v-card-title>

                      <v-card-text>
                        Každý 5. pracovní den v měsíci zde najdete aktuální seznam vašich zákazníků
                        v rozsahu a struktuře dle vyhlášky č. 408/2015 Sb. (příloha č. 17).
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="align-center mb-6">
      <v-col
        cols="12"
        sm="6"
        lg="4"
      >
        <v-card
          :to="{ name: 'plannedOutage' }"
          class="elevation-12 fill-height"
        >
          <div
            class="primary--text d-inline-flex justify-center arrange-link-title align-center pa-4"
          >
            <img
              src="@/assets/images/crossed-out-lightning.png"
              alt=""
            />
            <span class="pl-4">
              Plánované bezproudí
            </span>
          </div>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="4"
      >
        <v-card
          :to="{
            name: 'requests',
            query: $store.state.settings.filters.requests,
          }"
          class="elevation-12 fill-height"
        >
          <div
            class="primary--text d-inline-flex justify-center arrange-link-title align-center pa-4"
          >
            <img
              src="@/assets/images/list-icon.png"
              alt=""
            />
            <span class="pl-4">
              Přehled požadavků
            </span>
          </div>
        </v-card>
      </v-col>

      <v-col
        v-if="accessFor(['ROLE_ADMIN'])"
        cols="12"
        sm="6"
        lg="4"
      >
        <v-card
          :to="{ name: 'users' }"
          class="elevation-12 fill-height"
        >
          <div
            class="primary--text d-inline-flex justify-center arrange-link-title align-center pa-4"
          >
            <img
              src="@/assets/images/user-with-gear.png"
              alt=""
            />
            <span class="pl-4">
              Administrace uživatelů
            </span>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { checkAuth } from '@/components/mixins/checkAuth';

export default {
  name: 'NeedToArrange',
  mixins: [checkAuth],
  data() {
    return {
      tab: this.$store.state.settings.tabs.selectedTab,
      activeProcesses: process.env.ACTIVE_PROCESSES,
    };
  },
  methods: {
    saveSelectedTabToStore() {
      setTimeout(() => {
        this.$store.commit('settings/TABS_SELECTION', this.tab);
      }, 100);
    },
    isActiveProcess(processName) {
      return process.env.VUE_APP_ACTIVE_PROCESSES.includes(processName);
    },
  },
};
</script>
